import { render, staticRenderFns } from "./ses-send-email-output.vue?vue&type=template&id=1cbaa6dc&scoped=true"
import script from "./ses-send-email-output.vue?vue&type=script&lang=js"
export * from "./ses-send-email-output.vue?vue&type=script&lang=js"
import style0 from "./ses-send-email-output.vue?vue&type=style&index=0&id=1cbaa6dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbaa6dc",
  null
  
)

export default component.exports